import Cookies from "js-cookie";
import AuthenticationContext from "./AuthenticationContext.ts";
import React, { useEffect, useState, useCallback } from "react";

import { USER_TYPE } from "constants/constants.js";
import toast from "react-hot-toast";
// import AuthContext from "./AuthenticationContext.ts";

import useAxios from "../../services/useAxios.tsx";
// import sendRequest from "hooks/useAxios";
// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]
interface UserInformation {
  token: string;
  tokenTest?: string;
  fullName: string;
  userType: number;
  mobile: number;
  userName: string;
  accessLevel: number[];
  id: any;
  isFirst: boolean;
  addresses: any[];
  address: string;
  postalCode: string;
}

export default function Authentication({
  children,
}: {
  children: JSX.Element;
}) {
  const { execute: checkLoginInfoApi } = useAxios("api/checklogininfo");
  const { execute: getTokenTest } = useAxios("api/generate_token_test");
  const { execute: findAddressesApi } = useAxios("api/Find_UsersAddress");
  // kiani
  const [userInfo, setUserInfo] = useState<UserInformation>({
    token: "",
    fullName: "",
    tokenTest: "",
    userType: -1,
    mobile: 0,
    userName: "",
    accessLevel: [],
    id: null,
    isFirst: true,
    addresses: [],
    address: "",
    postalCode: "",
  });

  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [isChecked, setisChecked] = useState<boolean>(false);
  //   useEffect(() => {
  //     checkCookie();
  //   }, []);//shFazeli 1402/04/26

  function login(
    token: string,
    fullName: string,
    userType: number,
    mobile: number,
    userName: string,
    accessLevel: any[],
    id: any,
    addresses: any[],
    address: string,
    postalCode: string
  ): void {
    if (token) {
      // if (userType == 1) {
      //   accessLevel = [13, 14, 15, 16];
      // }
      setUserInfo({
        token,
        fullName,
        userType: userType,
        mobile,
        userName,
        accessLevel,
        id: id,
        isFirst: false,
        addresses: addresses,
        address,
        postalCode,
      });

      setIsLogged(true);
      Cookies.set("token", token);
    }
  }

  function logout(): void {
    setUserInfo((prev) => ({
      ...prev,
      token: "",
      fullName: "",
      userType: -1,
      mobile: 0,
      userName: "",
      accessLevel: [],
      id: null,
      isFirst: false,
      addresses: [],
      address: "",
      postalCode: "",
    }));
    setIsLogged(false);
    Cookies.remove("token");
  }
  const tokenTest = () => {
    console.log("checkLoginInfoApi check cookie get token test");

    getTokenTest({ uid: "-1" }).then(({ token }) => {
      console.log("checkLoginInfoApi check cookie get token test api");

      if (token) {
        Cookies.set("testToken", token);
        setUserInfo((prev) => ({ ...prev, tokenTest: token }));
        setisChecked(true);
      }
    });
  };
  function checkCookie(): void {
    if (Cookies.get("token")) {
      console.log("checkLoginInfoApi check cookie token");

      // sendRequest("checklogininfo", { usertoken: Cookies.get("token") }).then(
      checkLoginInfoApi().then((data) => {
        if (data.status == -1) {
          toast.error("کاربری با این مشخصات یافت نشد.");
          Cookies.remove("token");
          return "";
        }

        // let userType;
        // if (value.userinfo[0].isadmin == 1) {
        //   switch (+value.userinfo[0].user_admin_group) {
        //     case 1:
        //       userType = USER_TYPE.generalAdmin;
        //       break;
        //     case 2:
        //       userType = USER_TYPE.tourLeader;
        //       break;
        //     case 3:
        //       userType = USER_TYPE.accountants;
        //       break;
        //     case 4:
        //       userType = USER_TYPE.saleCounter;
        //       break;
        //     default:
        //       break;
        //   }
        // } else {
        //   userType = USER_TYPE.customer;
        // }
        let userType;
        login(
          Cookies.get("token"),
          // data.data.usertoken,
          data.userinfo[0].fname + " " + data.userinfo[0].lname,
          +data.userinfo[0].type,
          data.userinfo[0].mobile,
          "",
          [],
          +data.userinfo[0].id,
          data?.userinfo?.[0]?.addresses,
          data?.userinfo?.[0]?.address,
          data?.userinfo?.[0]?.postcode
        );
        setisChecked(true);
      });
    } else {
      //shFazeli 1402/04/26 start
      if (Cookies.get("testToken")) {
        setUserInfo((prev) => ({
          ...prev,
          tokenTest: Cookies.get("testToken"),
        }));
        setisChecked(true);
        return;
      }
      tokenTest();

      //shFazeli 1402/04/26 end
      // setUserInfo({
      //   token: "",
      //   fullName: "",
      //   userType: -1,
      //   mobile: 0,
      //   userName: "",
      //   accessLevel: [],
      //   id: null,
      //   isFirst: false,
      // });//shFazeli 1402/04/28
    }
  }

  useEffect(() => {
    if (isLogged) return;
    checkCookie(); //shFazeli 1402/04/26
  }, [isLogged]);

  const refreshAddresses = useCallback(async () => {
    await findAddressesApi({
      conditions: `user_id/=/${userInfo.id}@@status/!=/-1`,
    }).then((res) => {
      // dispatch({ type: AuthActionType.GetAddresses, payload: res });
      setUserInfo((prev) => ({ ...prev, addresses: res }));
    });
  }, [findAddressesApi, userInfo, userInfo.id]);
  return (
    <>
      <AuthenticationContext.Provider
        value={{
          login,
          userInfo,
          isLogged,
          isChecked,
          logout,
          refreshAddresses,
        }}
      >
        {children}
      </AuthenticationContext.Provider>
    </>
  );
}
// "ba68d1382a58515cba89dd9d07552625##2##1689587113"
